import type { PunditUserContext } from "@/react/contexts/punditUserContext";

export const isUserSignedIn = (punditUser?: PunditUserContext) =>
  !!punditUser?.currentUser?.id;
